import { useAppSelector } from "@app/store";
import Arrow from "@assets/icons/arrow-right.svg";
import Clock from "@assets/icons/clock.svg";
import Usdt from "@assets/icons/usdt.svg";
import { Button } from "@components/button";
import { useAuth } from "@features/auth";
import { useBalanceDispatch } from "@features/balance";
import { formatTime } from "@helpers/date";
import { useEffect, useRef, useState } from "react";
import { useLocation } from "react-router-dom";
import styles from "./header.module.scss";
import { formatUsdt } from "@helpers/format";
import { PayOutBalanceModal } from "@components/pay-out-balance-modal";
import { useBoolState } from "@hooks/use-bool-state";
import { useLead } from "@features/lead";
import { GradientCollection } from "@constants/gradients";
import { getRandomInt } from "@helpers/utilities";


const pages = [
  { text: "Сделки", link: "/deals" },
  { text: "Реквизиты", link: "/details" },
  { text: "Финансы", link: "/finance" },
  { text: "Устройства", link: "/devices" },
  { text: "Выводы", link: "/payouts" },
];

const getTitle = (path: string) => {
  const page = pages.find((page) => path.includes(page.link));

  return page?.text || "Главная";
};

const gerCurrentTime = () => formatTime(new Date());

export const LeadHeader = () => {
  const { state, getBalances } = useLead();
  const [time, setTime] = useState(gerCurrentTime());
  const [isModalOpen, showModal, hideModal] = useBoolState(false);

  useEffect(() => {
    const interval = setInterval(() => {
      setTime(gerCurrentTime());
    }, 1000);

    return () => {
      clearInterval(interval);
    };
  }, []);

  useEffect(() => {
    getBalances();
  }, [getBalances]);

  const usdtPrice = useAppSelector((state) => state.balance.usdtPrice);
  const { getUsdtPrice } = useBalanceDispatch();

  const rate = !usdtPrice ? "..." : usdtPrice;

  useEffect(() => {
    getUsdtPrice();

    const interval = setInterval(() => {
      getUsdtPrice();
    }, 60000);

    return () => {
      clearInterval(interval);
    };
  }, [getUsdtPrice]);

  return (
    <header className={styles.header}>
      <div className={styles.leadBlock}>
        <div className={styles.balance}>
          {state.balanceLoading || state.balance === null ? (
            <span>Загрузка...</span>
          ) : (
            <span>{formatUsdt(state.balance.amount)}</span>
          )}
        </div>
        <Button style={{ width: "auto" }} onClick={showModal}>
          Вывод
        </Button>
      </div>
      <div className={styles.container}>
        <div className={styles.infoBlock + " " + styles.infoClock}>
          <Clock />
          <span>{time}</span>
          <p>UTC +3 МСК</p>
        </div>
        <div className={styles.infoBlock}>
          <Usdt />
          <span>{typeof rate == "number" ? formatUsdt(rate, true) : rate}</span>
        </div>
        <User />
      </div>
      {state.balance != null && (
        <PayOutBalanceModal
          isModalOpen={isModalOpen}
          hideModal={hideModal}
          balance={state.balance.amount}
        />
      )}
    </header>
  );
};

export const Header = () => {
  const [time, setTime] = useState(gerCurrentTime());
  const location = useLocation();

  useEffect(() => {
    const interval = setInterval(() => {
      setTime(gerCurrentTime());
    }, 1000);

    return () => {
      clearInterval(interval);
    };
  }, []);

  const usdtPrice = useAppSelector((state) => state.balance.usdtPrice);
  const { getUsdtPrice } = useBalanceDispatch();

  const rate = !usdtPrice ? "..." : usdtPrice;

  useEffect(() => {
    getUsdtPrice();

    const interval = setInterval(() => {
      getUsdtPrice();
    }, 60000);

    return () => {
      clearInterval(interval);
    };
  }, [getUsdtPrice]);

  return (
    <header className={styles.header}>
      <h2 className={styles.title}>{getTitle(location.pathname)}</h2>
      <div className={styles.container}>
        <div className={styles.infoBlock + " " + styles.infoClock}> 
          <Clock />
          <span>{time}</span>
          <p>UTC +3 МСК</p>
        </div>
        <div className={styles.infoBlock}>
          <Usdt />
          <span>{typeof rate == "number" ? formatUsdt(rate, true) : rate}</span>
        </div>
        <User />
      </div>
    </header>
  );
};

const User = () => {
  const { logout, state } = useAuth();
  const [isDropdownOpen, setIsDropdownOpen] = useState(false);
  const [gradient, setGradient] = useState<string>("");

  const dropdownRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    const handleClickOutside = (event: MouseEvent) => {
      // eslint-disable-next-line @typescript-eslint/ban-ts-comment
      // @ts-expect-error
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setIsDropdownOpen(false);
      }
    };

    const rand = getRandomInt(0, GradientCollection.length);
    const gradient = GradientCollection[rand];
    if (gradient) {
      setGradient(gradient);
    }

    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  return (
    <div ref={dropdownRef} className={styles.userBlockContainer}>
      <div
        className={`${styles.infoBlock} ${styles.userBlock}`}
        onClick={() => setIsDropdownOpen((prev) => !prev)}
      >
        <div className={styles.avatar} style={{background: gradient}} >
        </div>
        <div className={styles.userContainer}>
          <div className={styles.userInfo}>
            <p className={styles.name}>{state.email}</p>
            <p className={styles.id}>{state.userId}</p>
          </div>
        </div>
      </div>
      {isDropdownOpen && (
        <div className={styles.dropdownMenu}>
          <Button className={styles.logoutButton} icon={Arrow} onClick={logout}>
            Выйти
          </Button>
        </div>
      )}
    </div>
  );
};
